import React from "react";
import { Helmet } from "react-helmet";
// import { useTranslation } from "react-i18next";
import HeaderTitle from "../../../components/header/headerTitle/headerTitle";
import Image from "../../../components/image";
import { asset } from "../../../helpers/dom.helper";
import "./style.scss";
import { AUTOMOTIVE } from './automotiveJson'
import { Link } from "react-router-dom";
import { toRoute } from "../../../i18n";
import { Media, MediaContextProvider } from "../../../media";


function Automotive(props) {
  // const { t } = useTranslation(["translation", "aboutUs"]);

  return (
    <>
      <Helmet>
        <title>Automotive | Lussopack</title>
        <meta name="description" content="Automotive | Lussopack" />
        <meta name="keywords" content="Automotive | Lussopack" />
        <link rel="canonical" href="https://lussopack.com/packaging/customized-projects/automotive" />
      </Helmet>

      {/* <ScrollToTopOnMount /> */}
      <HeaderTitle
        {...props}
        textHeader={"Customized Projects"}
        textSubHeader={"We are here to turn your dream of impeccable luxury packaging into a tangible reality."}
        isShowOurReference={true}
      />

      <MediaContextProvider>
        <Media greaterThanOrEqual="md">
          <div id="automotive">
          <h2 className="text-center">Automotive</h2>
          <div className="automotiveList">
            {
              AUTOMOTIVE.map((automotive, index)=>(
                <div className={`automotiveItem`} key={index}>
                  <Link to={toRoute(automotive.path)}>
                    <Image
                      src={asset(`${automotive.itemImageDesktop}`)}
                      alt={`${automotive.item}`}
                      className="img-fluid zoom"
                      width="345"
                      height="345"
                    />
                  </Link>
                  <Link to={toRoute(automotive.path)}>
                    <p className="text-center mt-2">{automotive.item}</p>
                  </Link>
                </div>
              ))
            }
            </div>
            <div className="descriptionConatainer">
              <p>Our expertise extends across diverse sectors, and we have left an indelible mark in the automotive industry. Notably, we have skillfully designed packaging solutions for the Automotive sector, including car key boxes. We understand that packaging is a reflection of a brand's essence, and our commitment to delivering high-quality is what sets us apart. Elevate your product presentation with Lussopack and let your packaging tell a story that you wish to convey.</p>
              <p>In the world of automotive packaging, ensuring the safety and security of vehicle keys is of importance. This is where the Automotive Key Box steps in as an essential component. Let's delve into the reasons why incorporating this element is crucial for any packaging company dealing with automobiles.</p>
              
               <h3><b>Security and Loss Prevention</b></h3>
              <p>One of the primary functions of an Automotive Key Box is to provide a secure and designated location for storing vehicle keys. This significantly reduces the risk of misplacement or theft during transportation and storage. By safeguarding keys within a dedicated box, the packaging company can offer peace of mind to both manufacturers and dealerships.</p>
              
               <h3><b>Organization and Efficiency</b></h3>
              <p>Efficiency in the automotive industry is a key factor for success. The Automotive Key Box aids in keeping keys organized, ensuring that the right key is readily available for each vehicle. This streamlines the process of handling multiple vehicles, particularly in scenarios involving large shipments or storage facilities.</p>
              
               <h3><b>Customization and Branding Opportunities</b></h3>
              <p>Packaging is an extension of a company's brand identity. An automotive key box offers customization options, allowing the packaging company to incorporate logos, branding elements, or specific design features. This not only enhances the visual appeal but also reinforces the professionalism and reliability associated with the packaging.</p>
              
               <h3><b>Protection from Environmental Factors</b></h3>
              <p>Vehicles, especially those in transit, are subjected to various environmental elements like dust, moisture, and temperature fluctuations. An automotive key box by Lussopack provides an extra layer of protection against these factors, ensuring that keys remain in optimal condition upon arrival at their destination.</p>

              <p>In the intricate tapestry of the automotive industry, every detail matters. Key boxes, though seemingly small, play a monumental role in ensuring the smooth operation of the supply chain. </p>
            </div>
          </div>
        </Media>
        <Media lessThan="md">
          <div id="automotiveMobile">
          <h2>Automotive</h2>
          <div className="automotiveList">
            {
              AUTOMOTIVE.map((automotive, index)=>(
                <div className={`automotiveItem`} key={index}>
                  <Link to={toRoute(automotive.path)}>
                    <Image
                      src={asset(`${automotive.itemImageDesktop}`)}
                      alt={`${automotive.item}`}
                      className="img-fluid"
                      width="345"
                      height="345"
                    />
                    <p>{automotive.item}</p>
                  </Link>
                </div>
              ))
            }
            </div>
            <div className="descriptionConatainer">
              <p>Our expertise extends across diverse sectors, and we have left an indelible mark in the automotive industry. Notably, we have skillfully designed packaging solutions for the Automotive sector, including car key boxes. We understand that packaging is a reflection of a brand's essence, and our commitment to delivering high-quality is what sets us apart. Elevate your product presentation with Lussopack and let your packaging tell a story that you wish to convey.</p>
              <p>In the world of automotive packaging, ensuring the safety and security of vehicle keys is of importance. This is where the Automotive Key Box steps in as an essential component. Let's delve into the reasons why incorporating this element is crucial for any packaging company dealing with automobiles.</p>
              
              <h3><b>Security and Loss Prevention</b></h3>
              <p>One of the primary functions of an Automotive Key Box is to provide a secure and designated location for storing vehicle keys. This significantly reduces the risk of misplacement or theft during transportation and storage. By safeguarding keys within a dedicated box, the packaging company can offer peace of mind to both manufacturers and dealerships.</p>
              
              <h3><b>Organization and Efficiency</b></h3>
              <p>Efficiency in the automotive industry is a key factor for success. The Automotive Key Box aids in keeping keys organized, ensuring that the right key is readily available for each vehicle. This streamlines the process of handling multiple vehicles, particularly in scenarios involving large shipments or storage facilities.</p>
              
              <h3><b>Customization and Branding Opportunities</b></h3>
              <p>Packaging is an extension of a company's brand identity. An automotive key box offers customization options, allowing the packaging company to incorporate logos, branding elements, or specific design features. This not only enhances the visual appeal but also reinforces the professionalism and reliability associated with the packaging.</p>
              
              <h3><b>Protection from Environmental Factors</b></h3>
              <p>Vehicles, especially those in transit, are subjected to various environmental elements like dust, moisture, and temperature fluctuations. An automotive key box by Lussopack provides an extra layer of protection against these factors, ensuring that keys remain in optimal condition upon arrival at their destination.</p>

              <p>In the intricate tapestry of the automotive industry, every detail matters. Key boxes, though seemingly small, play a monumental role in ensuring the smooth operation of the supply chain. </p>
            </div>
          </div>
        </Media>
      </MediaContextProvider>
    </>
  );
}

export default Automotive;
